module.exports = __webpack_public_path__ + "static/img/xeno-zapper_256.3dab94e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xeno-zapper_256.png
// module id = U6eo
// module chunks = 0